import { useLimits } from 'hooks/use-limits';
import { useGetMyOrganizationParticipationsQuery } from 'store/api/organizations';
import { OrganizationParticipation } from 'store/api/types';

export function hasApplicationParticipation(
  participations: OrganizationParticipation[] | undefined,
  alias: string,
) {
  return Boolean(participations?.some((item) => item.application?.alias === alias));
}

/** Доступ к прикладному сервису — участие с нужным `application.alias`. */
const GATE_DISABLED = true;

export function useHasApplicationParticipation(alias: string) {
  const { isLimitedUser, isLoading: limitsLoading } = useLimits();
  const { data, isLoading } = useGetMyOrganizationParticipationsQuery(undefined, {
    // Пункт меню снят. Пока гейт выключен, запрос участия не нужен.
    skip: GATE_DISABLED || isLimitedUser || limitsLoading,
  });

  return {
    // Включать проверку alias, только когда бэк стабильно отдаёт application.alias = assets.
    allowed: GATE_DISABLED || hasApplicationParticipation(data, alias),
    isLoading: GATE_DISABLED ? false : limitsLoading || isLoading,
  };
}
